import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import IPButton from '../../../../../components/IPButton'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import _ from 'lodash'
import IPInput from '../../../../../components/IPInput'
import { ISelectOption } from '../../../HomeAndSiteOperation/BulkAdding/components/BulkAdding'
import InputCampaign from '../../../../../components/InputCampaign'
import IPCheckbox from '../../../../../components/IPCheckBox'
import IPSelectBox from '../../../../../components/IPSelectBox/IPSelectBoxMenu'
import { getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import Swal from 'sweetalert2'
import CampaignSelect from '../../CampaignBundleCrud/components/CampaignSelect'
import '../../CampaignBundleCrud/components/CampaignBundleList.scss'
import { CampaignBundleService } from '../../CampaignBundleCrud/services/CampaignBundleService'
import { ICategoryList, ICompany } from '../../../components/models/models'
import { getCategoryList, getCompanyApi } from '../../../components/api'
import { GetPoductSubTypeListApi } from '../../CampaignBundleCrud/services/getPoductSubTypeListApi'
import { IProductAISuggestRequest } from '../models/ProductSuggestListModel'
import { AddProductAISuggestApi } from '../services/addProductAISuggest'
import { UpdateProductAISuggestApi } from '../services/updateProductAISuggest'

interface IAddProductColorState {
  condOpen: boolean
  condOpenNotSuggest: boolean
  update: boolean
  enabled: boolean
  productCodes: ISelectOption[]
  productCodesNotSuggest: ISelectOption[]
  productCodeOptions?: ISelectOption[]
  quotaCodeOptions?: ISelectOption[]
  categoryOptions?: ISelectOption[]
  productSubTypeOptions?: ISelectOption[]
  brandOptions?: string[]
  companyListOptions: ISelectOption[]
  companyOption: ISelectOption
  quotaList: ISelectOption[]
  quotaListNotSuggest: ISelectOption[]
  brandList: ISelectOption[]
  brandListNotSuggest: ISelectOption[]
  catList: ISelectOption[]
  catListNotSuggest: ISelectOption[]
  productSubTypeList: ISelectOption[]
  productSubTypeListNotSuggest: ISelectOption[]
  info: string
  name: string
  id?: number
  getProductCodeBool: boolean
  getBrandListBool: boolean
  getCategoryBool: boolean
  getProductSubTypesBool: boolean
  isBasket: boolean
  isDetail: boolean
}

function ProductSuggestAISettings(props: BaseComponentWithContextProps) {
  const getInitialState = (): IAddProductColorState => {
    return {
      condOpen: false,
      condOpenNotSuggest: false,
      update: false,
      companyOption: { label: '', value: '' },
      companyListOptions: [],
      productCodes: [],
      productCodesNotSuggest: [],
      quotaList: [],
      quotaListNotSuggest: [],
      brandList: [],
      brandListNotSuggest: [],
      catList: [],
      catListNotSuggest: [],
      productSubTypeList: [],
      productSubTypeListNotSuggest: [],
      info: '',
      name: '',
      enabled: true,
      getProductCodeBool: false,
      getBrandListBool: false,
      getCategoryBool: false,
      getProductSubTypesBool: false,
      isBasket: false,
      isDetail: false,
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IAddProductColorState>(intialState)
  const location = useLocation()
  let navigate = useNavigate()

  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)
  const [startDate, setStartDate] = useState(inititalStartDate)
  const [endDate, setEndDate] = useState(new Date())
  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(' ', 'T')
  }
  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const enumFunction = (takenState, takenEnum) => {
    return takenState === takenEnum ? 'active' : ''
  }

  const [productData, setProductData] = useState<ISelectOption[]>([])

  const onCreateOption = (option, updateFunc) => {
    updateFunc(prevState => {
      const newData = {
        value: option[option.length - 1].value,
        label: option[option.length - 1].label,
      }
      if (prevState && prevState.length > 0) {
        for (const state of prevState) {
          if (state.value === newData.value) return [...prevState]
          return [...prevState, newData]
        }
      }
      return [newData]
    })
  }

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Id,
      }))
      setState({ companyListOptions: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }


  const [inputValueCond, setInputValueCond] = useState('')
  const [inputValueCondNotSuggest, setInputValueCondNotSuggest] = useState('')

  const handleInputCondChange = event => {
    setInputValueCond(event.target.value)
  }

  const handleInputCondChangeNotSuggest = event => {
    setInputValueCondNotSuggest(event.target.value)
  }

  const handleInputKeyPressCond = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleAddValueCond()
    }
  }

  const handleInputKeyPressCondNotSuggest = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleAddValueCondNotSuggest()
    }
  }

  const handleAddValueCondNotSuggest = () => {
    if (inputValueCondNotSuggest.trim() !== '') {
      let prodList: { label: string; value: string }[] = []
      if (state.productCodesNotSuggest) {
        prodList = state.productCodesNotSuggest.map(item => ({
          label: item.label,
          value: String(item.value),
        }))
      }
      if (!state.productCodesNotSuggest?.some(item => item.label === inputValueCondNotSuggest)) {
        const newItem = { label: inputValueCondNotSuggest, value: inputValueCondNotSuggest }
        prodList.push(newItem)
      }
      setState({ productCodesNotSuggest: prodList })
      setInputValueCondNotSuggest('')
    }
  }

  const handleAddValueCond = () => {
    if (inputValueCond.trim() !== '') {
      let prodList: { label: string; value: string }[] = []

      if (state.productCodes) {
        prodList = state.productCodes.map(item => ({
          label: item.label,
          value: String(item.value),
        }))
      }
      if (!state.productCodes?.some(item => item.label === inputValueCond)) {
        const newItem = { label: inputValueCond, value: inputValueCond }
        prodList.push(newItem)
      }
      setState({ productCodes: prodList })
      setInputValueCond('')
    }
  }


  const getProductCode = async () => {
    const campaignBundleService = new CampaignBundleService({})
    const res = await campaignBundleService.getProductCode()
    if (res) {
      let temp = res.Entity.ProductsInfo.map(a => {
        return {
          label: a.ProductCode + '       ' + a.ProductName,
          value: a.ProductCode,
        }
      })
      setState({
        productCodeOptions: temp,
        quotaCodeOptions: res.Entity.QuotaCode.map(item => {
          return { label: item, value: item }
        }),
      })
    }
    setState({ getProductCodeBool: true })
  }

  const getBrandList = async () => {
    const campaignBundleService = new CampaignBundleService({})
    const res = await campaignBundleService.getBrandList()
    if (res) setState({ brandOptions: res.Entity?.BrandCode })
    setState({ getBrandListBool: true })
  }

  const getCategory = async () => {
    const data: ICategoryList[] = await getCategoryList()
    const categoryOptions: ISelectOption[] = []
    if (data) {
      data.map(dt => {
        return categoryOptions.push({ value: dt.SapCode, label: dt.Name })
      })
    }
    setState({ categoryOptions })
    setState({ getCategoryBool: true })
  }

  const getProductSubTypes = async () => {
    const getPoductSubTypeList: GetPoductSubTypeListApi = new GetPoductSubTypeListApi({})
    const res = await getPoductSubTypeList.getPoductSubTypeList()
    if (res) {
      const subType: ISelectOption[] = []
      res.forEach((item: any) => {
        item && subType.push({ value: item, label: item })
      })
      setState({ productSubTypeOptions: subType })
    }
    setState({ getProductSubTypesBool: true })
  }

  useEffect(() => {
    getCompanies()
    getProductCode()
    getBrandList()
    getCategory()
    getProductSubTypes()
  }, [])

  useEffect(() => {
    if (
      state.getProductCodeBool &&
      state.getBrandListBool &&
      state.getCategoryBool &&
      state.getProductSubTypesBool &&
      state.condOpen
    ) {
      props.hideLoading()
    } else {
      if (state.condOpen) props.showLoading()
    }
  }, [
    state.condOpen,
    state.getProductCodeBool,
    state.getBrandListBool,
    state.getCategoryBool,
    state.getProductSubTypesBool,
  ])

  useEffect(() => {
    if (location.state && location.state.linkData) {
      if (location.state.data === 'update') setState({ update: true })

      if (
        !(
          state.getProductCodeBool &&
          state.getBrandListBool &&
          state.getCategoryBool &&
          state.getProductSubTypesBool
        )
      ) {
        props.showLoading()
      } else {
        props.hideLoading()

        if (location.state.data === 'update') {
          setState({
            id: location.state.linkData.Id,
            isBasket: location.state.linkData.IsBasket,
            isDetail: location.state.linkData.IsDetail,
            enabled: location.state.linkData.Enabled,
            info: location.state.linkData.Info,
            name: location.state.linkData.Name,
            companyOption: state.companyListOptions.find(a => a.label == location.state.linkData.Company),
            productCodes: state.productCodeOptions?.filter(option =>
              location.state.linkData.ProductList.toString().split(',').includes(option.value)
            ),
            quotaList: state.quotaCodeOptions?.filter(option =>
              location.state.linkData.QuotaList.toString().split(',').includes(option.value)
            ),
            brandList: state.brandOptions
              ?.map(option => ({ label: option, value: option }))
              .filter(option => location.state.linkData.BrandList.includes(option.value)),

            productSubTypeList: state.productSubTypeOptions?.filter(option =>
              location.state.linkData.ProductSubTypeList.toString().split(',').includes(option.value)
            ),
            catList: state.categoryOptions?.filter(option =>
              location.state.linkData.CatList.toString().split(',').includes(option.value)
            ),
            productCodesNotSuggest: state.productCodeOptions?.filter(option =>
              location.state.linkData.ProductListNotSuggest.toString().split(',').includes(option.value)
            ),
            quotaListNotSuggest: state.quotaCodeOptions?.filter(option =>
              location.state.linkData.QuotaListNotSuggest.toString().split(',').includes(option.value)
            ),
            brandListNotSuggest: state.brandOptions
              ?.map(option => ({ label: option, value: option }))
              .filter(option => location.state.linkData.BrandListNotSuggest.includes(option.value))
            ,
            productSubTypeListNotSuggest: state.productSubTypeOptions?.filter(option =>
              location.state.linkData.ProductSubTypeListNotSuggest.toString().split(',').includes(option.value)
            ),
            catListNotSuggest: state.categoryOptions?.filter(option =>
              location.state.linkData.CatListNotSuggest.toString().split(',').includes(option.value)
            ),
          })
          setStartDate(location.state.linkData.StartDate)
          setEndDate(location.state.linkData.EndDate)
        }
      }
    }
  }, [
    state.getProductCodeBool,
    state.getBrandListBool,
    state.getCategoryBool,
    state.getProductSubTypesBool,
  ])

  const addSuggestion = async () => {
    props.showLoading()
    const req: IProductAISuggestRequest = {
      Id: state.id,
      Info: state.info,
      Name: state.name,
      Company: state.companyOption ? Number(state.companyOption.value) : 0,
      StartDate: getDateByTimezoneOffset(startDate),
      EndDate: getDateByTimezoneOffset(endDate),
      Enabled: state.enabled,
      ProductList: state.productCodes.map(a => a.value.toString()),
      BrandList: state.brandList.map(a => a.value.toString()),
      QuotaList: state.quotaList.map(a => a.value.toString()),
      CatList: state.catList.map(a => a.value.toString()),
      ProductSubTypeList: state.productSubTypeList.map(a => a.value.toString()),
      IsBasket: state.isBasket,
      IsDetail: state.isDetail,
      ProductListNotSuggest: state.productCodesNotSuggest.map(a => a.value.toString()),
      BrandListNotSuggest: state.brandListNotSuggest.map(a => a.value.toString()),
      QuotaListNotSuggest: state.quotaListNotSuggest.map(a => a.value.toString()),
      CatListNotSuggest: state.catListNotSuggest.map(a => a.value.toString()),
      ProductSubTypeListNotSuggest: state.productSubTypeListNotSuggest.map(a => a.value.toString())
    }

    if (state.update) {
      const updateSuggest: UpdateProductAISuggestApi = new UpdateProductAISuggestApi({})
      await updateSuggest
        .updateProductSuggest(req)
        .then(result => {
          if (result) {
            Swal.fire({
              icon: 'success',
              title: 'Ürün önerme kaydı güncellendi',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
          navigate('/admin/ProductOperation/ProductSuggestList')
        })
        .catch((err: any) => {
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
          props.hideLoading()
        })
    } else {
      const addSuggest: AddProductAISuggestApi = new AddProductAISuggestApi({})
      await addSuggest
        .addProductSuggest(req)
        .then(result => {
          if (result) {
            Swal.fire({
              icon: 'success',
              title: 'Ürün önerme kaydı eklendi',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
          navigate('/admin/ProductOperation/ProductSuggestList')
        })
        .catch((err: any) => {
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
          props.hideLoading()
        })
    }
  }

  return (
    <div className='container addProductLimitation'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'>AI Önerme Ayarları</span>
            <Link to='/admin/ProductOperation/ProductSuggestList'>
              <IPButton
                type='button'
                className='btn btn-primary m-l-10'
                text='Listeye Dön'
                style={{ width: '25px', marginRight: '10px' }}
              />
            </Link>
          </div>
          <div className='row m-5'>
            <div className='col-md-3'>
              <label>Önerme Adı</label>
              <IPInput
                type='text'
                id='Name'
                className='form-control'
                name='Name'
                value={state.name}
                onChange={e => setState({ name: e.target.value })}
              />
            </div>
            <div className='col-md-5'>
              <label>Açıklama</label>
              <IPInput
                type='text'
                id='Title'
                className='form-control'
                name='Title'
                value={state.info}
                onChange={e => setState({ info: e.target.value })}
              />
            </div>
            <div className='col-md-2'>
              <br></br>
              <InputCampaign
                type='datetime-local'
                id='StartDate'
                name='StartDate'
                label={'Başlangıç Tarihi'}
                value={toDateTimeLocal(startDate)}
                onChange={e => getDate(e.target.value, 'Start')}
                isActive
              />
            </div>
            <div className='col-md-2'>
              <br></br>
              <InputCampaign
                type='datetime-local'
                id='EndDate'
                name='EndDate'
                label={'Bitiş Tarihi'}
                value={toDateTimeLocal(endDate)}
                onChange={e => getDate(e.target.value, 'End')}
                isActive
              />
            </div>
          </div>
          <div>
            <div className='row m-5'>
              <div className='col-md-3'>
                <label>Şirket</label>
                <IPSelectBox
                  isClearable
                  className='Company'
                  name='Company'
                  options={state.companyListOptions}
                  value={state.companyOption}
                  onChangeSingle={option => {
                    setState({ companyOption: option })
                  }}
                />
              </div>
              <div className='col-md-2 mt-5'>
                <IPCheckbox
                  name='Basket'
                  onClick={() => setState({ isBasket: !state.isBasket })}
                  checked={state.isBasket}
                  label={'Sepette Uygula'}
                />
              </div>
              <div className='col-md-3 mt-5'>
                <IPCheckbox
                  name='Detail'
                  onClick={() => setState({ isDetail: !state.isDetail })}
                  checked={state.isDetail}
                  label={'Ürün Detayda Uygula'}
                />
              </div>
              <div className='col-md-2 mt-5'>
                <IPCheckbox
                  name='Active'
                  onClick={() => setState({ enabled: !state.enabled })}
                  checked={state.enabled}
                  label={'Aktif'}
                />
              </div>
            </div>
            <br></br>
            <label className='w-100 text-center' id='conditions'>
              <span
                style={{ fontWeight: 'bold', cursor: 'pointer' }}
                onClick={() => setState({ condOpen: !state.condOpen })}
              >
                ÖNERMESİ KISITLANACAK ÜRÜN KOŞULLARI
              </span>
            </label>
            {state.condOpen && (
              <div className='campaignWrap m-5' style={{ backgroundColor: 'white', minHeight: '50vh' }}>
                <div className='topAreaListGroup'>
                  <div>
                    <div
                      className='topAreaInputGroup position-relative'
                      data-toggle='tooltip'
                      data-placement='top'
                      title='Ürün Adı'
                    >
                      <div className='w-100 text-center'>Ürün Kodu</div>
                      <CampaignSelect
                        //options={state.productCodeOptions}
                        value={state.productCodes}
                        onChangeMulti={(options: ISelectOption[]) => setState({ productCodes: options })}
                        placeholder={'Ürün Kodu'}
                        menuStyle={true}
                      />
                      <input
                        type='text'
                        placeholder='Ürün kodu yazın'
                        value={inputValueCond}
                        onChange={handleInputCondChange}
                        onKeyPress={handleInputKeyPressCond}
                      />
                    </div>
                  </div>

                  <div>
                    <div className='topAreaInputGroup position-relative'>
                      <div className='w-100 text-center'>Kota</div>
                      <CampaignSelect
                        options={state.quotaCodeOptions}
                        placeholder={'Quota Kodu'}
                        value={state.quotaList}
                        onChangeMulti={options => setState({ quotaList: options })}
                      />
                    </div>
                  </div>

                  <div className='topAreaInputGroup position-relative'>
                    <div className='w-100 text-center'>Kategori</div>
                    <CampaignSelect
                      placeholder={'Kategori'}
                      value={state.catList}
                      options={state.categoryOptions}
                      onChangeMulti={options => setState({ catList: options })}
                    />
                  </div>

                  <div className='topAreaInputGroup position-relative'>
                    <div className='w-100 text-center'>Marka</div>
                    <CampaignSelect
                      placeholder={'Marka'}
                      options={state.brandOptions?.map(item => {
                        return { label: item, value: item }
                      })}
                      // placeholder={location.state ? campaignBasketConditions.map(a => a.XBrandList) : 'Marka Kodu'}
                      value={state.brandList}
                      onChangeMulti={options => setState({ brandList: options })}
                    />
                  </div>

                  <div className='topAreaInputGroup position-relative'>
                    <div className='w-100 text-center'>Ürün Alt Tipi</div>
                    <CampaignSelect
                      options={state.productSubTypeOptions}
                      placeholder={'Alt Tip Kodu'}
                      // placeholder={
                      //   location.state ? campaignBasketConditions.map(a => a.XProductSubTypeList) : 'Alt Tip Kodu'
                      // }
                      value={state.productSubTypeList}
                      onChangeMulti={options => setState({ productSubTypeList: options })}
                    />
                  </div>
                </div>
              </div>
            )}

            <label className='w-100 text-center mt-5' id='conditionsNotSuggest'>
              <span
                style={{ fontWeight: 'bold', cursor: 'pointer' }}
                onClick={() => setState({ condOpenNotSuggest: !state.condOpenNotSuggest })}
              >
                ÖNERİLMEYECEK ÜRÜN KOŞULLARI
              </span>
            </label>
            {state.condOpenNotSuggest && (
              <div className='campaignWrap m-5' style={{ backgroundColor: 'white', minHeight: '50vh' }}>
                <div className='topAreaListGroup'>
                  <div>
                    <div
                      className='topAreaInputGroup position-relative'
                      data-toggle='tooltip'
                      data-placement='top'
                      title='Ürün Adı'
                    >
                      <div className='w-100 text-center'>Ürün Kodu</div>
                      <CampaignSelect
                        //options={state.productCodeOptions}
                        value={state.productCodesNotSuggest}
                        onChangeMulti={(options: ISelectOption[]) => setState({ productCodesNotSuggest: options })}
                        placeholder={'Ürün Kodu'}
                        menuStyle={true}
                      />
                      <input
                        type='text'
                        placeholder='Ürün kodu yazın'
                        value={inputValueCondNotSuggest}
                        onChange={handleInputCondChangeNotSuggest}
                        onKeyPress={handleInputKeyPressCondNotSuggest}
                      />
                    </div>
                  </div>

                  <div>
                    <div className='topAreaInputGroup position-relative'>
                      <div className='w-100 text-center'>Kota</div>
                      <CampaignSelect
                        options={state.quotaCodeOptions}
                        placeholder={'Quota Kodu'}
                        value={state.quotaListNotSuggest}
                        onChangeMulti={options => setState({ quotaListNotSuggest: options })}
                      />
                    </div>
                  </div>

                  <div className='topAreaInputGroup position-relative'>
                    <div className='w-100 text-center'>Kategori</div>
                    <CampaignSelect
                      placeholder={'Kategori'}
                      value={state.catListNotSuggest}
                      options={state.categoryOptions}
                      onChangeMulti={options => setState({ catListNotSuggest: options })}
                    />
                  </div>

                  <div className='topAreaInputGroup position-relative'>
                    <div className='w-100 text-center'>Marka</div>
                    <CampaignSelect
                      placeholder={'Marka'}
                      options={state.brandOptions?.map(item => {
                        return { label: item, value: item }
                      })}
                      // placeholder={location.state ? campaignBasketConditions.map(a => a.XBrandList) : 'Marka Kodu'}
                      value={state.brandListNotSuggest}
                      onChangeMulti={options => setState({ brandListNotSuggest: options })}
                    />
                  </div>

                  <div className='topAreaInputGroup position-relative'>
                    <div className='w-100 text-center'>Ürün Alt Tipi</div>
                    <CampaignSelect
                      options={state.productSubTypeOptions}
                      placeholder={'Alt Tip Kodu'}
                      // placeholder={
                      //   location.state ? campaignBasketConditions.map(a => a.XProductSubTypeList) : 'Alt Tip Kodu'
                      // }
                      value={state.productSubTypeListNotSuggest}
                      onChangeMulti={options => setState({ productSubTypeListNotSuggest: options })}
                    />
                  </div>
                </div>
              </div>
            )}


            <div className='row m-5' style={{ display: 'flex', justifyContent: 'end' }}>
              <div className='col-md-6 m-5' style={{ display: 'flex', justifyContent: 'end' }}>
                <IPButton
                  text='Kaydet'
                  type='button'
                  className='btn btn-success w-25'
                  onClick={addSuggestion}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(ProductSuggestAISettings)
